
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Guide des formats publicitaires sur Facebook : lequel choisir ?",
    description:
      "Découvrez les formats publicitaires Facebook qui fonctionnent (image, vidéo, Stories, carrousel) et comment les optimiser avec ALEO pour des campagnes performantes.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
